// extracted by mini-css-extract-plugin
export default {"root":"XqVyiLOTo_5B1rdrCzeK","label":"pcEuJ9bziORB7I1jMwsr"};